import { useEffect, useReducer, useState } from 'react';
import DateBox from 'devextreme-react/date-box';
import TextBox from 'devextreme-react/text-box';
import { Validator, RequiredRule, EmailRule } from 'devextreme-react/validator';
import { Toast } from 'devextreme-react/toast';
import { saveMassCommunication } from '../../actions/dashboard';
import { timeConverter } from './utils';
import Button from 'devextreme-react/button';
import '../../styles/scss/gallery.scss';
import galleryReducer from '../../reducers/gallery';
import * as action from '../../actions/gallery';

const initialState = { gallery: [] }

const MassCommunication = () => {
    const [state, dispatch] = useReducer(galleryReducer, initialState)
    const [currStartDate, setCurrStartDate] = useState(new Date())
    const [currEndDate, setCurrEndDate] = useState(new Date())
    const [title, setTitle] = useState('')
    const [toastConfig, setToastConfig] = useState({ isVisible: false, type: 'info', message: '' });



    const [showMailer, enableMailer] = useState(false)
    const resetFrm = () => { setTitle(''); setCurrStartDate(new Date()); setCurrEndDate(new Date()); }

    const { gallery } = state
    const [toggleForm, setToggleForm] = useState(false)

    useEffect(() => {
        action.fetchGallery(dispatch, null)
    }, [])

    const sendNotification = () => {
        let sub = title.trim();
        let startDateTime = new Date(currStartDate);
        let endDateTime = new Date(currEndDate);

        if (sub && sub.length > 0) {
            let massCommData = {
                'message': sub,
                'startDateTime': timeConverter(startDateTime.toISOString()),
                'endDateTime': timeConverter(endDateTime.toISOString()),
                'isSent': false
            };

            saveMassCommunication(dispatch, massCommData)
            resetFrm()
            setToastConfig({ ...toastConfig, isVisible: true, type: 'success', message: 'Notification Saved!' });
        }
    }
    return (
        <>
            <div>
                <div className="dx-field">
                    <div className="dx-field-label"><h1>Mass Communication</h1></div>
                </div>
                <div className="dx-field">
                    <div className="dx-field-label">Start Date Time*</div>
                    <div className="dx-field"> <DateBox className="dx-field-value" defaultValue={currStartDate}
                        type="datetime"
                        onValueChanged={e => setCurrStartDate(e.value)} useMaskBehavior={true}
                    >
                        <Validator><RequiredRule message="Start Date Time is required" /> </Validator>
                    </DateBox>
                    </div>
                </div>
                <div className="dx-field">
                    <div className="dx-field-label">End Date Time*</div>
                    <div className="dx-field"> <DateBox className="dx-field-value" defaultValue={currEndDate}
                        type="datetime"
                        onValueChanged={e => setCurrEndDate(e.value)} useMaskBehavior={true}
                    >
                        <Validator><RequiredRule message="End Date Time is required" /></Validator>
                    </DateBox>
                    </div>
                </div>
                <div className="dx-field">
                    <div className="dx-field-label">Message*</div>
                    <div className="dx-field">
                        <TextBox name="Message" value={title} onValueChanged={e => setTitle(e.value)} className="dx-field-value" >
                            <Validator><RequiredRule message="Message is required" /> </Validator>
                        </TextBox></div>
                </div>
                <div className="cbtn" style={{ "textAlign": "right" }}>
                    <Button style={{ "marginRight": "14px" }} onClick={() => { enableMailer(false); resetFrm(); }} text="Cancel" type="normal" />
                    <Button onClick={sendNotification} text="Notify" type="success" useSubmitBehavior={true} />
                </div>

                <Toast
                    visible={toastConfig.isVisible}
                    message={toastConfig.message}
                    type={toastConfig.type}
                    onHiding={() => setToastConfig({
                        ...toastConfig,
                        isVisible: false,
                    })}
                    displayTime={2000}
                />
            </div>
        </>
    )
}
export default MassCommunication;